import { IValidatorFn } from '../../../lib/interfaces/IValidatorFn';

export enum ColumnPatternType {
	Cast = 'Cast',
	Upper = 'Upper',
	Lower = 'Lower',
	Trim = 'Trim'
}

export enum ColumnPatternCondition {
	MATCHES = 'Matches',
	STARTS_WITH = 'StartsWith',
	ENDS_WITH = 'EndsWith',
	HAS_VALUE = 'HasValue'
}

export enum DataType {
	INTEGER = 'integer',
	SHORT = 'short',
	LONG = 'long',
	STRING = 'string',
	FLOAT = 'float',
	DECIMAL = 'decimal',
	DATE = 'date',
	BINARY = 'binary',
	TIMESTAMP = 'timestamp',
	ARRAY = 'array'
}

export interface IDataTypeDetails {
	name: DataTypeParameter,
	userFriendlyName: string,
	type: DataType,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	value: any;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	selectedValue: any;

	validations: IValidatorFn[];
}

export enum DataTypeParameter {
	Format = 'format',
	Scale = 'scale',
	Precision = 'precision',
	Locale = 'locale'
}

export interface IColumnPatternConfiguration {
	columnPatterns: IColumnPatternOnSource[],
	applyOnExistingMappings: boolean
}

export interface IColumnPatternOnSource {
	type: ColumnPatternType,
	rules: IColumnPatternRule[];
}

export interface IColumnPatternRule {
	matchingCondition: ColumnPatternCondition,
	matchingConditionValue: string,
	exceptCondition: ColumnPatternCondition,
	exceptConditionValue: string,
}

export interface ICastingRule extends IColumnPatternRule {
	fromType: DataType;
	toType: DataType;
	requiredInputs: IDataTypeDetails[];
}


export class CastingRuleUtil {
	public static getDataTypeDetails(parameter: DataTypeParameter, requiredInputs: IDataTypeDetails[]): IDataTypeDetails {
		for (const requiredInput of requiredInputs) {
			if (requiredInput && requiredInput.name === parameter) {
				return requiredInput;
			}
		}

		return undefined;
	}
}
